import { render, staticRenderFns } from "./salesarea.vue?vue&type=template&id=f58708d0&scoped=true&"
import script from "./salesarea.vue?vue&type=script&lang=js&"
export * from "./salesarea.vue?vue&type=script&lang=js&"
import style0 from "./salesarea.vue?vue&type=style&index=0&id=f58708d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58708d0",
  null
  
)

export default component.exports